<template>
	<div class="flex flex-col user-tagging-list">
		<scroll-wrapper>
			<user-tagging-list-item v-for="(user, index) in users" :key="index" :user="user">
				<template #checkbox>
					<Checkbox id="tagging-checkbox" :value="user.enabled" @input="onInput($event, user)" />
				</template>
			</user-tagging-list-item>
		</scroll-wrapper>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import UserTaggingListItem from './UserTaggingListItem'
import Checkbox from '~/components/interface/Checkbox'
import ScrollWrapper from '~/components/interface/ScrollWrapper'
import analytics from '~/assets/util/analytics'

export default {
	name: 'UserTaggingList',
	components: {
		UserTaggingListItem,
		Checkbox,
		ScrollWrapper
	},
	inject: {
		mainEvent: {
			default: null
		}
	},
	props: {
		users: {
			type: Array,
			default: () => []
		},
		isTaggingOnTag: {
			type: Boolean,
			default: false
		},
		activePlayback: {
			type: Object,
			default: null
		}
	},
	methods: {
		...mapActions({ analyticsTrack: 'analytics/track' }),

		onInput ($event, user) {
			this.$emit('user-tag-changed', { id: user.id, value: $event, isAdmin: user.isAdmin, user })

			if ($event) {
				this.analyticsTrack({
					event: analytics.TagMemberChecked.event,
					data: analytics.TagMemberChecked.getData({
						activePlayback: this.activePlayback,
						clubId: this.mainEvent.clubId,
						mainEvent: this.mainEvent,
						userId: user.id,
						...(this.isTaggingOnTag && { isTag: true })
					})
				})
			} else {
				this.analyticsTrack({
					event: analytics.TagMemberUnchecked.event,
					data: analytics.TagMemberUnchecked.getData({
						activePlayback: this.activePlayback,
						clubId: this.mainEvent.clubId,
						mainEvent: this.mainEvent,
						userId: user.id,
						...(this.isTaggingOnTag && { isTag: true })
					})
				})
			}
		}
	}
}
</script>

<style lang="scss">
#tagging-checkbox {
	margin-left: 21px;
	.checkbox-checkmark {
		width: 18px;
		height: 18px;
		border: 1px solid #84d5ee;
		background: transparent;

		&:after {
			border-color: #84d5ee;
			top: 3px;
			left: 3px;
			width: 8px;
			height: 4px;
		}
	}
}
</style>
